enum DefaultModBehavior {
  UseSystemDefault = 'use-system-default',
  Send = 'send',
  DoNotSend = 'do-not-send',
}

export { DefaultModBehavior };
